// src/components/ChannelList.js

import React, { useEffect, useState } from 'react'
import { db } from '../firebase'
import { collection, query, where, onSnapshot } from 'firebase/firestore'
import { useAuth } from '../contexts/AuthContext'
import {
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography
} from '@mui/material'
import ForumIcon from '@mui/icons-material/Forum'

// Çoklu dil desteği
import { useTranslation } from 'react-i18next'

export default function ChannelList({ workspaceId, onChannelSelect, selectedChannel }) {
  const { t } = useTranslation() // i18n Hook

  const [channels, setChannels] = useState([])
  const { currentUser } = useAuth()

  useEffect(() => {
    if (!workspaceId) return

    const channelsRef = collection(db, 'channels')
    const q = query(
      channelsRef,
      where('workspaceId', '==', workspaceId),
      where('showChannelLink', '==', true),
      where('members', 'array-contains', currentUser.uid)
    )

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const channelData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }))
      setChannels(channelData)
    })

    return () => unsubscribe()
  }, [workspaceId, currentUser])

  const handleClick = (channel) => {
    if (onChannelSelect) {
      onChannelSelect(channel)
    }
  }

  if (channels.length === 0) {
    return (
      <Typography color="textSecondary">
        {t('channelList.noChannels')}
      </Typography>
    )
  }

  return (
    <List>
      {channels.map((channel) => (
        <ListItem
          button
          key={channel.id}
          selected={selectedChannel?.id === channel.id}
          onClick={() => handleClick(channel)}
          sx={{
            borderRadius: 1,
            mb: 1,
            backgroundColor: selectedChannel?.id === channel.id ? '#F0C1E1' : '#f1f1f1',
            '&:hover': {
              backgroundColor: '#C5D3E8'
            }
          }}
        >
          <ListItemAvatar>
            <Avatar>
              <ForumIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={channel.name}
            // Üye sayısını i18n ile formatlıyoruz
            secondary={t('channelList.memberCount', {
              count: channel.members?.length || 0
            })}
          />
        </ListItem>
      ))}
    </List>
  )
}